import { MarkDownFormatter } from '@/common';
import { ChatAiCodeBlock } from './ChatAiCodeBlock';
import { ChatAiTable } from './ChatAiTable';
import type { Components } from 'react-markdown';

export function ChatMarkDownFormatter({ content }: { content: string }) {
  const componentOverrides: Partial<Components> = {
    code: ({ children, className }) => {
      const isBlock = className?.includes('language-');
      return isBlock ? (
        <ChatAiCodeBlock className={className}>{children}</ChatAiCodeBlock>
      ) : (
        <code className="bg-gray-100 text-pink-600 px-1.5 py-0.5 rounded text-xs font-mono whitespace-pre-wrap">
          {children}
        </code>
      );
    },
    table: ({ children }) => <ChatAiTable>{children}</ChatAiTable>,
  };

  return <MarkDownFormatter content={content} componentOverrides={componentOverrides} />;
}
